'use strict';

import angular from 'angular';
import template from './modal.pug';

const PositionModalSvc = [
  'ModalSvc',
  'LoaderSvc',
  'DatetimeSvc',
  'PositionTypeSvc',
  'PositionSvc',
  function(
    ModalSvc,
    LoaderSvc,
    DatetimeSvc,
    PositionTypeSvc,
    PositionSvc
  ) {
    /**
     * Opens the groupRole Modal
     * @param  {Object} currentGrpRle   - currentPos
     * @return {Object}                 - the updated pos instance
     */
    function open(currentPos, groupId, personId) {
      LoaderSvc.start();
      var modalInstance;
      var positionvm = angular.copy(currentPos);
      positionvm = DatetimeSvc.getFormDateRange(positionvm); // add dates
      var modalvm = {};

      modalvm.title = currentPos.id ? 'Edit Position' : 'Create Position';
      var customPosition = {
        id: 'custom',
        name: 'Custom',
        isActive: true,
        displayOrder: 10000
      };

      PositionTypeSvc.query({groupId})
        .$promise
        .then(function(pt) {
          modalvm.positionTypes = pt;
          if(positionvm.customType) {
            positionvm.typeId = customPosition.id;
          }
          modalvm.positionTypes.push(customPosition);
          LoaderSvc.stop();
        });

      // datepicker
      modalvm.dateFormat = 'M/d/yyyy';
      modalvm.openActive = function($event, dateType) {
        $event.preventDefault();
        $event.stopPropagation();
        positionvm[dateType + 'Open'] = true;
      };

      modalvm.changeStart = function() {
        var formStart = new Date(positionvm.formStart);
        var formEnd;
        // reset end if start is updated
        if(positionvm.formEnd) { formEnd = new Date(positionvm.formEnd); }
        if(formEnd && formEnd < formStart) { positionvm.formEnd = null; }
      };

      modalvm.clearEnd = function() {
        positionvm.formEnd = null;
        modalvm.formvm.$setDirty();
      };

      // submit
      function onSubmit() {
        modalvm.submitted = true; // modal submits outside of form

        if(modalvm.formvm.$valid) {
          LoaderSvc.start();
          // prep position object
          if(positionvm.typeId !== 'custom') {
            delete positionvm.customType;
          } else {
            positionvm.typeId = null;
          }
          // set dates from form values
          DatetimeSvc.setDatesBasedOnForm(positionvm);

          positionvm.groupId = groupId;
          positionvm.personId = personId;

          // create
          if(!currentPos.id) {
            PositionSvc.save({groupId}, positionvm).$promise
              .then(function() {
                LoaderSvc.stopSuccess('Position Created');
                modalInstance.close();
              }).catch(function(e) {
                LoaderSvc.stopError(e.message);
                modalInstance.close();
              });
          } else {
          // update
            //check for difference in attributes
            if(currentPos.start) {
              currentPos.start = DatetimeSvc.getDatePropString(
                currentPos.start
              );
            }
            // set undefined to null
            currentPos.start = currentPos.start || null;
            if(currentPos.end) {
              currentPos.end = DatetimeSvc.getDatePropString(currentPos.end,
                true);
            }
            currentPos.end = currentPos.end || null; // set undefined to null
            var posTypeId = positionvm.typeId ? positionvm.typeId : null;
            var curTypeId = currentPos.typeId ? currentPos.typeId : null;
            positionvm.customType = positionvm.customType || null;

            // check for update
            if(posTypeId !== curTypeId
            || positionvm.customType !== currentPos.customType
            || positionvm.start !== currentPos.start
            || positionvm.end !== currentPos.end) {
              PositionSvc.update({groupId}, positionvm).$promise
                .then(function() {
                  LoaderSvc.stopSuccess('Position Updated');
                  modalInstance.close();
                }).catch(function(e) {
                  LoaderSvc.stopError(e.message);
                  modalInstance.close();
                });
            } else {
              LoaderSvc.stop();
              modalInstance.close();
            }
          }
        }
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      var modalScope = {modalvm: angular.extend(modalvm, {
        dismissable: true,
        positionvm,
        onSubmit,
        buttons: [
          {classes: 'btn-primary', text: 'Update', click: onSubmit},
          {classes: 'btn-default', text: 'Cancel', click: onCancel}
        ]
      })};

      var options = {size: 'lg', template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];
export default PositionModalSvc;
